import api from '@src/api/clients';

const defaultRequest = (url) =>
  api.request({
    url,
    method: 'GET',
  });

export const normalizeNextUrl = (next) => {
  if (!next) {
    return null;
  }

  try {
    const parsed = new URL(next, window.location.origin);
    const relative = `${parsed.pathname}${parsed.search}`;
    let trimmed = relative.startsWith('/') ? relative.slice(1) : relative;
    if (trimmed.startsWith('api/')) {
      trimmed = trimmed.slice(4);
    }
    return trimmed;
  } catch (err) {
    return next.startsWith('/') ? next.slice(1) : next;
  }
};

const sanitizeFilters = (filters = {}) =>
  Object.fromEntries(
    Object.entries(filters).filter(([, value]) => value !== '' && value !== null && value !== undefined)
  );

export const fetchAllFilteredClientZips = async ({
  baseFilters = {},
  pageSize,
  requestFn = defaultRequest,
} = {}) => {
  const filters = sanitizeFilters(baseFilters);
  const params = new URLSearchParams({ page: 1 });
  if (pageSize) {
    params.set('page_size', pageSize);
  }
  Object.entries(filters).forEach(([key, value]) => {
    params.set(key, value);
  });

  let nextUrl = `dashboard/client-zips/?${params.toString()}`;
  const visitedUrls = new Set();
  const seenIds = new Set();
  const rows = [];
  let expectedCount = null;

  while (nextUrl && !visitedUrls.has(nextUrl)) {
    visitedUrls.add(nextUrl);
    // eslint-disable-next-line no-await-in-loop
    const res = await requestFn(nextUrl);
    const { data } = res || {};
    const { results = [], next, count } = data || {};

    if (expectedCount === null && typeof count === 'number') {
      expectedCount = count;
    }

    results.forEach((zip) => {
      if (zip && !seenIds.has(zip.id)) {
        seenIds.add(zip.id);
        rows.push(zip);
      }
    });

    const normalizedNext = normalizeNextUrl(next);
    if (normalizedNext && !visitedUrls.has(normalizedNext)) {
      nextUrl = normalizedNext;
    } else {
      nextUrl = null;
    }
  }

  if (expectedCount !== null && rows.length !== expectedCount) {
    console.warn(`Expected ${expectedCount} client ZIP rows but collected ${rows.length}.`);
  }

  return rows;
};

export default fetchAllFilteredClientZips;
